import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const CAMPOS_TIENDA = [
  { key:'tienda_nombre',   label:'Nombre de la tienda',    ph:'Wawita Eco Friendly' },
  { key:'tienda_email',    label:'Email de contacto',       ph:'contacto@wawitaeco.com' },
  { key:'tienda_telefono', label:'WhatsApp / Teléfono',     ph:'+57 300...' },
  { key:'tienda_ciudad',   label:'Ciudad',                  ph:'Pasto, Nariño' },
];

const CAMPOS_ENVIO = [
  { key:'envio_ciudad_local',     label:'Ciudad con tarifa local',        ph:'Pasto',  tipo:'text' },
  { key:'envio_precio_local',     label:'Precio envío local (COP)',        ph:'5000',   tipo:'number' },
  { key:'envio_precio_nacional',  label:'Precio envío nacional (COP)',     ph:'13000',  tipo:'number' },
  { key:'envio_gratis_desde',     label:'Envío gratis desde (COP)',        ph:'100000', tipo:'number' },
];

const fmtCOP = v => v ? new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(Number(v)) : '';

export default function Configuracion() {
  const [config, setConfig] = useState({});

  useEffect(() => {
    api.get('/config').then(r => setConfig(r.data)).catch(()=>{});
  }, []);

  const guardar = async (clave, valor) => {
    try {
      await api.put(`/config/${clave}`, { valor });
      toast.success('Guardado ✅');
    } catch { toast.error('Error al guardar'); }
  };

  const CampoConfig = ({ f }) => (
    <div className="form-group" key={f.key}>
      <label className="form-label">{f.label}</label>
      <div style={{ display:'flex', gap:10, alignItems:'center' }}>
        <input
          className="form-input"
          type={f.tipo || 'text'}
          placeholder={f.ph}
          value={config[f.key] || ''}
          onChange={e => setConfig(c => ({ ...c, [f.key]: e.target.value }))}
        />
        <button
          className="btn btn-outline btn-sm"
          style={{ whiteSpace:'nowrap' }}
          onClick={() => guardar(f.key, config[f.key])}
        >
          Guardar
        </button>
      </div>
      {f.tipo === 'number' && config[f.key] && (
        <div style={{ fontSize:11, color:'var(--ink-faint)', marginTop:4 }}>
          = {fmtCOP(config[f.key])}
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', position:'sticky', top:0, zIndex:10 }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Configuración</h1>
      </div>

      <div style={{ padding:'24px 28px', maxWidth:640 }}>

        {/* Control del sitio */}
        <div className="card" style={{ marginBottom:20 }}>
          <div className="card-header"><span className="card-title">🌐 Estado del sitio</span></div>
          <div className="card-body">
            <div style={{ marginBottom:16, fontSize:13, color:'var(--ink-faint)', lineHeight:1.7 }}>
              Controla la visibilidad del sitio. El panel admin siempre estará accesible.
            </div>
            {[
              { val:'activo',        icon:'✅', label:'Activo',        desc:'Sitio visible para todos', color:'#2D5A30' },
              { val:'mantenimiento', icon:'🔧', label:'Mantenimiento', desc:'Visitantes ven página en construcción', color:'#C4632A' },
            ].map(m => (
              <div key={m.val} onClick={async () => {
                try {
                  await api.put('/config/modo_sitio', { valor: m.val });
                  setConfig(c => ({ ...c, modo_sitio: m.val }));
                  toast.success('Modo cambiado a: ' + m.label);
                  // Recargar para aplicar cambios
                  setTimeout(() => window.location.reload(), 1000);
                } catch { toast.error('Error al cambiar modo'); }
              }} style={{ display:'flex', alignItems:'center', gap:14, padding:'16px', borderRadius:'var(--r-md)', border:`2px solid ${config.modo_sitio===m.val ? m.color : 'rgba(28,58,30,0.1)'}`, background: config.modo_sitio===m.val ? (m.val==='activo'?'rgba(45,90,48,0.08)':'rgba(196,99,42,0.08)') : '#fff', cursor:'pointer', marginBottom:10, transition:'all 0.2s' }}>
                <span style={{ fontSize:28 }}>{m.icon}</span>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:15, color: m.val===config.modo_sitio ? m.color : 'var(--forest)' }}>{m.label}</div>
                  <div style={{ fontSize:12, color:'var(--ink-faint)', marginTop:2 }}>{m.desc}</div>
                </div>
                {config.modo_sitio === m.val && <span style={{ fontSize:12, fontWeight:700, color: m.color, background: m.val==='activo'?'rgba(45,90,48,0.1)':'rgba(196,99,42,0.1)', padding:'4px 10px', borderRadius:20 }}>ACTIVO</span>}
              </div>
            ))}
          </div>
        </div>

        {/* Tienda */}
        <div className="card" style={{ marginBottom:20 }}>
          <div className="card-header"><span className="card-title">Información de la tienda</span></div>
          <div className="card-body">
            {CAMPOS_TIENDA.map(f => <CampoConfig key={f.key} f={f} />)}
          </div>
        </div>

        {/* Envíos */}
        <div className="card" style={{ marginBottom:20 }}>
          <div className="card-header">
            <span className="card-title">🚚 Tarifas de envío</span>
          </div>
          <div className="card-body">
            <div style={{ background:'rgba(159,190,106,0.1)', borderRadius:'var(--r-sm)', padding:'12px 16px', marginBottom:20, fontSize:13, color:'var(--ink-mid)', lineHeight:1.7 }}>
              <strong>Lógica actual:</strong><br/>
              • La ciudad local recibe tarifa especial (más baja)<br/>
              • Todas las demás ciudades pagan la tarifa nacional<br/>
              • Si el pedido supera el mínimo → envío gratis automático
            </div>
            {CAMPOS_ENVIO.map(f => <CampoConfig key={f.key} f={f} />)}

            {/* Preview */}
            {config.envio_precio_local && config.envio_precio_nacional && (
              <div style={{ marginTop:16, background:'var(--cream)', borderRadius:'var(--r-md)', padding:'14px 18px', border:'1px solid rgba(28,58,30,0.08)' }}>
                <div style={{ fontSize:12, fontWeight:700, color:'var(--ink-faint)', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:12 }}>Vista previa</div>
                <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13 }}>
                    <span>📍 {config.envio_ciudad_local || 'Pasto'} (local)</span>
                    <strong style={{ color:'var(--forest)' }}>{fmtCOP(config.envio_precio_local)}</strong>
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13 }}>
                    <span>🇨🇴 Resto de Colombia</span>
                    <strong style={{ color:'var(--forest)' }}>{fmtCOP(config.envio_precio_nacional)}</strong>
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:13 }}>
                    <span>🎁 Envío gratis desde</span>
                    <strong style={{ color:'var(--sage)' }}>{fmtCOP(config.envio_gratis_desde)}</strong>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Próximas integraciones */}
        <div className="card">
          <div className="card-header"><span className="card-title">Próximas integraciones</span></div>
          <div className="card-body">
            {[
              { icon:'💳', label:'Wompi / Bancolombia', desc:'Pagos en línea — Fase 2', estado:'Próximamente' },
              { icon:'📧', label:'Email automático',     desc:'Facturas y notificaciones — Fase 2', estado:'Próximamente' },
              { icon:'📦', label:'Backup automático',    desc:'Respaldo diario de la BD', estado:'Próximamente' },
            ].map(i => (
              <div key={i.label} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom:'1px solid var(--border)' }}>
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                  <span style={{ fontSize:24 }}>{i.icon}</span>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14 }}>{i.label}</div>
                    <div style={{ fontSize:12, color:'var(--text-muted)' }}>{i.desc}</div>
                  </div>
                </div>
                <span className="badge badge-gray">{i.estado}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
